import { type z } from 'zod';

import {
  CONDITIONAL_BOOLEAN_CONDITION_SCHEMAS,
  CONDITIONAL_DATE_CONDITION_SCHEMAS,
  CONDITIONAL_DATE_TIME_CONDITION_SCHEMAS,
  CONDITIONAL_NUMBER_CONDITION_SCHEMAS,
  CONDITIONAL_STRING_CONDITION_SCHEMAS,
  CONDITIONAL_VALUE_CONDITION_SCHEMAS,
  ConditionalFieldDataType,
  type ConditionalOperation,
} from '../utils/conditionalConfig.js';

export const OPERATIONS_BY_SUPPORTED_DATA_TYPE: Record<
  ConditionalFieldDataType,
  ConditionalOperation[]
> = {
  [ConditionalFieldDataType.String]: CONDITIONAL_STRING_CONDITION_SCHEMAS.map(
    (schema) => schema.shape.operation.value
  ),
  [ConditionalFieldDataType.Number]: CONDITIONAL_NUMBER_CONDITION_SCHEMAS.map(
    (schema) => schema.shape.operation.value
  ),
  [ConditionalFieldDataType.Date]: CONDITIONAL_DATE_CONDITION_SCHEMAS.map(
    (schema) => schema.shape.operation.value
  ),
  [ConditionalFieldDataType.DateTime]: CONDITIONAL_DATE_TIME_CONDITION_SCHEMAS.map(
    (schema) => schema.shape.operation.value
  ),
  [ConditionalFieldDataType.Boolean]: CONDITIONAL_BOOLEAN_CONDITION_SCHEMAS.map(
    (schema) => schema.shape.operation.value
  ),
  [ConditionalFieldDataType.Value]: CONDITIONAL_VALUE_CONDITION_SCHEMAS.map(
    (schema) => schema.shape.operation.value
  ),
};

export const VALUES_SUPPORTED_BY_DATA_TYPE: Record<
  ConditionalFieldDataType,
  Record<ConditionalOperation, string[]>
> = {
  [ConditionalFieldDataType.String]: CONDITIONAL_STRING_CONDITION_SCHEMAS.reduce(
    (acc, schema) => {
      acc[schema.shape.operation.value] = getSupportedValues(schema);
      return acc;
    },
    {} as Record<ConditionalOperation, string[]>
  ),
  [ConditionalFieldDataType.Number]: CONDITIONAL_NUMBER_CONDITION_SCHEMAS.reduce(
    (acc, schema) => {
      acc[schema.shape.operation.value] = getSupportedValues(schema);
      return acc;
    },
    {} as Record<ConditionalOperation, string[]>
  ),
  [ConditionalFieldDataType.Date]: CONDITIONAL_DATE_CONDITION_SCHEMAS.reduce(
    (acc, schema) => {
      acc[schema.shape.operation.value] = getSupportedValues(schema);
      return acc;
    },
    {} as Record<ConditionalOperation, string[]>
  ),
  [ConditionalFieldDataType.DateTime]: CONDITIONAL_DATE_TIME_CONDITION_SCHEMAS.reduce(
    (acc, schema) => {
      acc[schema.shape.operation.value] = getSupportedValues(schema);
      return acc;
    },
    {} as Record<ConditionalOperation, string[]>
  ),
  [ConditionalFieldDataType.Boolean]: CONDITIONAL_BOOLEAN_CONDITION_SCHEMAS.reduce(
    (acc, schema) => {
      acc[schema.shape.operation.value] = getSupportedValues(schema);
      return acc;
    },
    {} as Record<ConditionalOperation, string[]>
  ),
  [ConditionalFieldDataType.Value]: CONDITIONAL_VALUE_CONDITION_SCHEMAS.reduce(
    (acc, schema) => {
      acc[schema.shape.operation.value] = getSupportedValues(schema);
      return acc;
    },
    {} as Record<ConditionalOperation, string[]>
  ),
};

function getSupportedValues(schema: z.ZodObject<z.ZodRawShape>) {
  const supportedValues = [];
  if ('value' in schema.shape) {
    supportedValues.push('value');
  }
  if ('minValue' in schema.shape) {
    supportedValues.push('minValue');
  }
  if ('maxValue' in schema.shape) {
    supportedValues.push('maxValue');
  }
  if ('minValueInclusive' in schema.shape) {
    supportedValues.push('minValueInclusive');
  }
  if ('maxValueInclusive' in schema.shape) {
    supportedValues.push('maxValueInclusive');
  }
  if ('caseSensitivity' in schema.shape) {
    supportedValues.push('caseSensitivity');
  }
  return supportedValues;
}
